import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Ship(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M10 3a1 1 0 011-1h2.5a1 1 0 110 2H11a1 1 0 01-1-1zm-.646 4a1 1 0 00-.928.629l-.993 2.482 3.84-.96a3 3 0 011.455 0l3.84.96-.994-2.482A1 1 0 0014.646 7H9.354zm9.603 3.708a.996.996 0 00-.029-.08l-1.497-3.742A3 3 0 0014.646 5H9.354A3 3 0 006.57 6.886l-1.497 3.743c-.011.026-.02.053-.029.08l-.315.078a2 2 0 00-1.456 2.426l1.536 6.144c-.252.058-.486.12-.7.182a12.535 12.535 0 00-1.416.503l-.087.039-.009.004a1 1 0 10.847 1.811l.054-.024a10.494 10.494 0 011.165-.412c.8-.23 1.917-.46 3.184-.46 1.28 0 2.576.231 3.976.484l.042.008c1.356.245 2.815.508 4.29.508a13.603 13.603 0 004.845-.913 8.735 8.735 0 00.396-.168l.009-.004a1 1 0 10-.847-1.812l-.054.024a10.5 10.5 0 01-1.256.438l1.5-6.376a2 2 0 00-1.461-2.398l-.33-.083zM7.847 19c-.365 0-.717.016-1.055.044l-1.58-6.316 6.546-1.637a1 1 0 01.485 0l6.558 1.64-1.7 7.227c-.304.027-.62.042-.947.042-1.28 0-2.576-.231-3.976-.484l-.042-.008C10.78 19.263 9.321 19 7.846 19z",
    clipRule: "evenodd"
  }));
}

export default Ship;